export default function () {
  if (document.getElementById('invoice-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "invoice-vue-app" */ '@organisms/invoice/main');
  }
}
